import script from "./goods.vue?vue&type=script&setup=true&lang=js"
export * from "./goods.vue?vue&type=script&setup=true&lang=js"

import "./goods.vue?vue&type=style&index=0&id=d3bc12e8&lang=scss&scoped=true"

import exportComponent from "D:\\workCode\\PC\\web-middleground\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d3bc12e8"]])

export default __exports__